import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  PriceDiscoveryRequest,
  PriceDiscoveryResponse,
} from '../../dto/price-discovery-dto';

type FetchPriceDiscoveryOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function fetchPriceDiscovery(
  baseUrl: string,
  payload: PriceDiscoveryRequest,
  options?: FetchPriceDiscoveryOptions,
): Promise<IHttpResponse<PriceDiscoveryResponse>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<PriceDiscoveryRequest> = {
    url: `${baseUrl}/api/v1/discover-price`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: PriceDiscoveryRequest,
      response: PriceDiscoveryResponse,
    },
    ...restOptions,
  };

  return httpCall(request);
}
